import { Box } from '@shared/ui';
import type React from 'react';
import TimeSelect from '../TimeSelect';
import type { EditableAvailabilityWindow } from './availabilityTransforms';

interface AvailabilityWindowFieldsProps {
  window: EditableAvailabilityWindow;
  disabled?: boolean;
  onChange: (window: EditableAvailabilityWindow) => void;
}

const AvailabilityWindowFields: React.FC<AvailabilityWindowFieldsProps> = ({
  window,
  disabled = false,
  onChange,
}) => {
  return (
    <Box sx={{ alignItems: 'center', display: 'flex', gap: 1.5, flexWrap: 'nowrap' }}>
      <TimeSelect
        label="Start time"
        value={window.start_time}
        disabled={disabled}
        onChange={(startTime) => onChange({ ...window, start_time: startTime })}
      />
      <Box component="span" sx={{ color: '#262626', fontSize: 14, lineHeight: 1 }}>
        -
      </Box>
      <TimeSelect
        label="End time"
        value={window.end_time}
        disabled={disabled}
        onChange={(endTime) => onChange({ ...window, end_time: endTime })}
      />
    </Box>
  );
};

export default AvailabilityWindowFields;
